import React from 'react';
import {motion, AnimatePresence} from 'framer-motion';

const AchievementNotification = ({notifications}) => {
  return (
    <div className="fixed top-20 right-4 z-[100] space-y-3 pointer-events-none">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{opacity: 0, x: 100, scale: 0.8}}
            animate={{opacity: 1, x: 0, scale: 1}}
            exit={{opacity: 0, x: 100, scale: 0.8}}
            className="bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-400 text-white px-6 py-4 rounded-2xl shadow-2xl border-4 border-white pointer-events-auto"
          >
            <div className="flex items-center gap-3">
              <div className="text-4xl animate-bounce">
                {notification.achievement.icon}
              </div>
              <div>
                <div className="font-black text-sm mb-1">🎉 成就解鎖!</div>
                <div className="font-bold text-xs opacity-90">
                  {notification.achievement.name}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default AchievementNotification;